import { isDisplayOnlyBlock } from './toolPairing';
function getContentBlocks(message) {
  return Array.isArray(message.content) ? message.content : [];
}

/**
 * A later MESSAGE_APPEND for an already-present message can carry DISPLAY_ONLY
 * blocks the server appended after the message first streamed in — notably the
 * TOOL_APPROVAL_REQUEST block on a paused turn. Naively no-op'ing the duplicate
 * append drops those blocks (and the credit-consent preview they carry), so the
 * approval UI never sees them.
 *
 * This narrowly merges in only NEW display-only blocks (deduped by block id),
 * preserving the existing message otherwise. Returns `null` when there is
 * nothing new to merge, so every other duplicate append — model content,
 * resume/recovery replays, optimistic — keeps the caller's original no-op and
 * its behavior is unchanged.
 */
export function mergeLateDisplayBlocks(existing, incoming) {
  const existingContent = getContentBlocks(existing);
  const incomingContent = getContentBlocks(incoming);
  const existingDisplayBlockIds = new Set(existingContent.filter(isDisplayOnlyBlock).map(block => block.id));
  const appendedDisplayBlocks = incomingContent.filter(isDisplayOnlyBlock).filter(block => !existingDisplayBlockIds.has(block.id));
  if (appendedDisplayBlocks.length === 0) return null;
  return Object.assign({}, existing, {
    content: [...existingContent, ...appendedDisplayBlocks]
  });
}